import { render, staticRenderFns } from "./useRecord.vue?vue&type=template&id=a8b490c2&scoped=true&"
import script from "./useRecord.vue?vue&type=script&lang=js&"
export * from "./useRecord.vue?vue&type=script&lang=js&"
import style0 from "./useRecord.vue?vue&type=style&index=0&id=a8b490c2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8b490c2",
  null
  
)

export default component.exports